import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "left", padding: "90px" }}>
          <Col
            md={10}
            style={{
              justifyContent: "justifyContent",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
          <p style={{ textAlign: "center", fontSize: "1.5em"}}>
            <span className="purple">Commands(22):</span>
          </p>
          <p style={{ textAlign: "justify", fontSize: "0.9em" }}>
            <br />Heres a list of all my commands, which you can use currently. Type <span className="purple">/ </span>to use them.<p style={{fontSize: "0.9em"}}>(Arguments surrounded in <span className="yellow">[ ]</span> are required arguments, while <span className="yellow">()</span> are not required to pass in.)</p>
          </p>
          <p style={{ textAlign: "justify" }}>
            <p className="home-about-body"><span className="purple">Astronomy Commands(14):</span></p>
            <ul>
              <li className="about-activity">
                <span className="purple">find <span className="yellow">[celestial]:</span></span> Fetch any celestial-body in our Solar System or even beyond.
              </li>
              <li className="about-activity">
                <span className="purple">lookup <span className="yellow">[id]:</span></span> Lookup a specific Asteroid based on its ID.
              </li>
              <li className="about-activity">
                <span className="purple">search <span className="yellow">[keywords]:</span></span> Search images or videos in NASA's library.
              </li>
              <li className="about-activity">
                 <span className="purple">apod <span className="yellow">(custom_date):</span></span>  View the Astronomy Picture Of the Day.
              </li>
              <li className="about-activity">
                 <span className="purple">neo:</span> Get a list of the current Near-Earth-Objects.
              </li>
              <li className="about-activity">
                 <span className="purple">insight:</span> Get weather updates on Mars.
              </li>
              <li className="about-activity">
                 <span className="purple">epic: <span className="yellow">(custom_date)</span></span> View an image of Earth and it's astronomical events.
              </li>
              <li className="about-activity">
                 <span className="purple">eclipses:</span> See the nex eclipses in 10 years.
              </li>
              <li className="about-activity">
                 <span className="purple">astronauts:</span> View the current number of people who are in space.
              </li>
              <li className="about-activity">
                 <span className="purple">iss:</span> Get the International Space Station's current location.
              </li>
              <li className="about-activity">
                 <span className="purple">fact:</span> Read intresting facts about our wondeful galaxy.
              </li>
              <li className="about-activity">
                 <span className="purple">moonphase <span className="yellow">[location] (day) (month) (year):</span></span> Get moon phase information for a specific area or time.
              </li>
              <li className="about-activity">
                 <span className="purple">database:</span> Fetch my celestial-database.
              </li>
              <li className="about-activity">
                 <span className="purple">impact <span className="yellow">[diameter] </span><span className="yellow">[velocity] </span><span className="yellow">[angle]: </span></span>Simulate an impact.
              </li>
            </ul>
          </p>
          <p className="home-about-body"><span className="purple">Daily Services(3):</span></p>
            <ul>
            <li className="about-activity">
               <span className="purple">apod_service <span className="yellow">[subscribe/unsubscribe] [channel]:</span></span> Subscribe/unsubscribe from APOD service.
            </li>
            <li className="about-activity">
               <span className="purple">moonphase_service <span className="yellow">[subscribe/unsubscribe] [channel]:</span></span> Subscribe/unsubscribe from Moonphase service.
            </li>
            <li className="about-activity">
               <span className="purple">fact_service <span className="yellow">[subscribe/unsubscribe] [channel]:</span></span> Subscribe/unsubscribe from Space fact service.
            </li>
            </ul>
          <p className="home-about-body"><span className="purple">Bot Commands(5):</span></p>
            <ul>
              <li className="about-activity">
                 <span className="purple">report <span className="yellow">[description]:</span></span> Report bugs to help my developer improving me.
              </li>
              <li className="about-activity">
                 <span className="purple">devlog:</span> Get the latest dev-log from my developer.
              </li>
              <li className="about-activity">
                 <span className="purple">info:</span> View bot information.
              </li>
              <li className="about-activity">
                 <span className="purple">ping:</span> Test my response latency.
              </li>
              <li className="about-activity">
                 <span className="purple">help:</span> Get a list of my available commands.
              </li>
            </ul>
        </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
